import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import FailedTabsContent from '../components/FailedTabsContent';
interface FailedTabsProps {
  onLogout: () => void;
}
export default function FailedTabs({
  onLogout
}: FailedTabsProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-4059">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Failed Tabs" data-id="element-4060" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="failed-tabs" data-id="element-4061" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: 'calc(100% - 240px)'
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-4062">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-4063">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-4064">
            <Icon icon="lucide:folder-kanban" width={28} height={28} color="#EF4444" data-id="element-4065" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-4066">
              Failed Tabs
            </Typography>
          </Box>
          <FailedTabsContent data-id="element-4067" />
        </Box>
      </Box>
    </Box>;
}